import './adaptive-carousel.scss'

import { Carousel } from '@plurix/ecom-components'
import React, { useEffect, useRef, useState } from 'react'

import { isScrollToEnd } from '../../../../utils/scroll/isScrollToEnd'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { carouselProps } from '../../../utils/carouselProps'

import type { CarouselPropsWithoutChildren } from '../../../hooks/useVerticalShelfCarouselProps'

interface AdaptiveCarouselProps {
  quantity: number
  children: React.ReactNode
  quantityToCarousel?: number
  propsCarousel?: CarouselPropsWithoutChildren
  activeBlur?: boolean
  forceCarousel?: boolean
}

export const AdaptiveCarousel = ({
  quantity,
  children,
  quantityToCarousel = 6,
  propsCarousel,
  activeBlur = true,
  forceCarousel,
}: AdaptiveCarouselProps) => {
  const refHistoryFilter = useRef<HTMLDivElement>(null)
  const [isClient, setIsClient] = useState(false)
  const [activeBlurAction, setActiveBlurAction] = useState({
    left: false,
    right: false,
  })
  const { width } = useWindowDimensions()
  const isCarousel = forceCarousel || quantity >= quantityToCarousel
  const carouselFinalProps: CarouselPropsWithoutChildren = {
    ...carouselProps(width ?? 0),
    ...propsCarousel,
  }

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (isCarousel && activeBlur) {
      const elementCarouselContainer =
        refHistoryFilter?.current?.querySelector('.carousel-container') ?? null

      const scrollToHorizontally = () => {
        setActiveBlurAction({
          left: !!elementCarouselContainer?.scrollLeft,
          right: !isScrollToEnd(elementCarouselContainer),
        })
      }

      scrollToHorizontally()

      elementCarouselContainer?.addEventListener(
        'scroll',
        scrollToHorizontally,
        {
          passive: false,
        }
      )

      return () =>
        elementCarouselContainer?.removeEventListener(
          'scroll',
          scrollToHorizontally
        )
    }

    return
  }, [isClient, isCarousel, activeBlur])

  if (!isClient) {
    return null
  }

  return (
    <div
      className={`adaptiveCarousel-container ${
        isCarousel ? 'isCarousel' : 'notCarousel'
      }`}
      ref={refHistoryFilter}
    >
      {isCarousel ? (
        <>
          {activeBlur && activeBlurAction?.left && (
            <div className="background-blur-left" />
          )}
          <Carousel {...carouselFinalProps}>{children}</Carousel>
          {activeBlur && activeBlurAction?.right && (
            <div className="background-blur-right" />
          )}
        </>
      ) : (
        children
      )}
    </div>
  )
}
